import { writable as _writable } from "svelte/store";
export function writable(key, initialValue) {
    const sessionValue = JSON.parse(sessionStorage.getItem(key));
    const store = _writable(sessionValue || initialValue);
    store.subscribe((value) => sessionStorage.setItem(key, JSON.stringify(value)));
    return store;
}
